import type { DeepPartial } from '@luna/utils-ts';
import type { ExportFeatureConfig, TransactionsFeatureConfig } from '@shared/transactions-config';

export const transactions: DeepPartial<TransactionsFeatureConfig> = {
    showBankFee: false,
    showTransactionFee: true,
    showSymbols: false,
    showPurposeCode: true,
    showSenderName: true,
    showReceiverName: true,
    showSenderAddress: true,
    showReceiverAddress: true,
    showSenderFieldsForAllPayments: true,
    showReceiverFieldsForAllPayments: true,
};

export const exportFeatures: DeepPartial<ExportFeatureConfig> = {
    lastExportOption: true,
    sortParams: ['BOOKING_DATE_ASC', 'BOOKING_DATE_DESC', 'AMOUNT_ASC', 'AMOUNT_DESC'],
    fields: [
        { name: 'senderName', preselected: true, selectable: true },
        { name: 'senderAddress', preselected: true, selectable: true },
        {
            name: 'senderAccountIban',
            preselected: true,
            selectable: true,
            labelKey: 'export.fields.senderIban',
        },
        {
            name: 'senderAccountNumber',
            preselected: true,
            selectable: true,
            labelKey: 'export.fields.senderNumber',
        },
        { name: 'senderReference', preselected: true, selectable: true },
        { name: 'senderModeReference', preselected: true, selectable: true },

        { name: 'receiverName', preselected: true, selectable: true },
        { name: 'receiverAddress', preselected: true, selectable: true },
        {
            name: 'receiverAccountIban',
            preselected: true,
            selectable: true,
            labelKey: 'export.fields.receiverIban',
        },
        {
            name: 'receiverAccountNumber',
            preselected: true,
            selectable: true,
            labelKey: 'export.fields.receiverNumber',
        },
        { name: 'receiverModeReference', preselected: true, selectable: true },

        { name: 'booking', preselected: true, selectable: true },
        { name: 'valuation', preselected: false, selectable: true },
        {
            name: 'exchangeRateValue',
            preselected: false,
            selectable: true,
            labelKey: 'export.fields.exchangeRate',
        },
        {
            name: 'execution',
            preselected: true,
            selectable: true,
            labelKey: 'export.fields.executionDate',
        },
        { name: 'transferDate', preselected: false, selectable: true },

        { name: 'amount', preselected: false, selectable: true },
        { name: 'currency', preselected: false, selectable: true },

        { name: 'symbolConstant', preselected: false, selectable: true },
        { name: 'reference', preselected: false, selectable: true },

        { name: 'cardBrand', preselected: true, selectable: true },
        { name: 'cardNumber', preselected: true, selectable: true },
        { name: 'cardLocation', preselected: true, selectable: true },
        { name: 'referenceNumber', preselected: true, selectable: true },
        { name: 'loanReference', preselected: true, selectable: true },
    ],
};
